"use client";

import React from "react";
import ContentBlock from "./ContentBlock";
import MediaBlock from "./MediaBlock";
import HighlightBlock from "./HighlightBlock";

const blockComponents: Record<string, React.FC<any>> = {
  content: ContentBlock,
  media: MediaBlock,
  highlight: HighlightBlock,
};

export default function RenderBlocks({ blocks }: { blocks: any[] }) {
  if (!blocks || !Array.isArray(blocks)) return null;

  return (
    <div className="page-blocks-layout-container">
      {blocks.map((block, index) => {
        const BlockComponent = blockComponents[block.blockType];
        if (!BlockComponent) {
          console.warn(`Block type "${block.blockType}" not found.`);
          return null;
        }

        return (
          <div key={`${block.blockType}-${index}`} className={`block-wrapper block-${block.blockType}`}>
            <BlockComponent {...block} />
          </div>
        );
      })}
    </div>
  );
}
